/*
  Global conf for bootstrap-vue toser
 */

export default {
  methods: {
    mxToast(title, message, variant = "danger") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: title,
        toaster: "b-toaster-top-center",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
  },
};
